// Models
import {Record} from "../../models"

type MetaData = Record["metaData"] | null | undefined
type PatientInfo = Record["patientInfo"] | null | undefined


/**
 * @param value
 */
function toFiniteNumber(value: number | string | null | undefined): number | null {
    if (typeof value === "number") {
        return isFinite(value) ? value : null
    }

    // patientInfo.age has been seen as a numeric string. Reject the empty
    // string explicitly — Number("") is 0, which would print an age of 0.
    if (typeof value === "string" && value.trim() !== "") {
        const parsed = Number(value);

        return isNaN(parsed) ? null : parsed
    }

    return null
}

/**
 * Age in years, or null when neither side carries one.
 *
 * @param metaData
 * @param patientInfo
 */
export function patientAge(metaData: MetaData, patientInfo: PatientInfo): number | null {
    const fromMeta = toFiniteNumber(metaData ? metaData.age : null);

    if (fromMeta !== null) {
        return fromMeta
    }

    return toFiniteNumber(patientInfo ? patientInfo.age : null)
}

/**
 * Raw sex code (MALE / FEMALE) for the `records.<code>` i18n key, or null.
 *
 * @param metaData
 * @param patientInfo
 */
export function patientSex(metaData: MetaData, patientInfo: PatientInfo): string | null {
    return (metaData && metaData.sex) || (patientInfo && patientInfo.sex) || null
}

/** Under-18 records get the pediatric chip. Unknown age is NOT pediatric. */
export function isPediatric(metaData: MetaData, patientInfo: PatientInfo): boolean {
    const age = patientAge(metaData, patientInfo);

    return age !== null && age < 18
}
